export default __webpack_public_path__ + "static/media/up_arrow.4acd01c8.svg";